import { CorvidState } from '../VideoPlayer.types';

const mapActionsToProps = ({ updateProps }: { updateProps: any }) => ({
  updateState: (props: CorvidState) => {
    updateProps({ ...props });
  },
});

export default mapActionsToProps;
